/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetModelShortResponseDto
 */
export interface AssetModelShortResponseDto {
    /**
     * 
     * @type {string}
     * @memberof AssetModelShortResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof AssetModelShortResponseDto
     */
    name: string;
}

/**
 * Check if a given object implements the AssetModelShortResponseDto interface.
 */
export function instanceOfAssetModelShortResponseDto(value: object): value is AssetModelShortResponseDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function AssetModelShortResponseDtoFromJSON(json: any): AssetModelShortResponseDto {
    return AssetModelShortResponseDtoFromJSONTyped(json, false);
}

export function AssetModelShortResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetModelShortResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
    };
}

export function AssetModelShortResponseDtoToJSON(json: any): AssetModelShortResponseDto {
    return AssetModelShortResponseDtoToJSONTyped(json, false);
}

export function AssetModelShortResponseDtoToJSONTyped(value?: AssetModelShortResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
    };
}

